import { createAction, props } from '@ngrx/store';

export const loadQuestions = createAction('[CIP] Load Questions');
export const loadQuestionsSuccess = createAction('[CIP] Load Questions Success', props<{questions: any[]}>());
export const loadQuestionsFailure = createAction('[CIP] Load Questions Failure', props<{error: string}>());
